module.exports = __webpack_public_path__ + "img/preferential.11c8eb21.png";